import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { EmptyState } from 'app/agriculture/components/EmptyState/EmptyState';
import { DeviceIcon } from 'app/agriculture/icons/devices/DeviceIcon';
import { SearchField } from 'app/agriculture/infobox/common/SearchField/SearchField';
import { useCallback, useState } from 'react';
import { WeatherStationListTable } from 'app/agriculture/routes/Devices/WeatherStationList/components/WeatherStationListTable';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import 'app/agriculture/routes/Devices/WeatherStationList/components/WeatherStationListComponent.scss';
import { LevelMonitorListTableSkeleton } from 'app/agriculture/routes/Devices/LevelMonitorList/components/LevelMonitorListTableSkeleton';
import { useWeatherStationResults } from 'app/agriculture/routes/Devices/WeatherStationList/hooks/useWeatherStationResults';

export function WeatherStationListComponent() {
    const [textFilter, setTextFilter] = useState('');
    const [disableTableSort, setDisableTableSort] = useState(false);
    const weatherStationResults = useWeatherStationResults(textFilter);

    const handleTextFilterChange = useCallback((textFilter: string) => {
        setTextFilter(textFilter);
        setDisableTableSort(true);
    }, []);

    const handleTableSort = useCallback(() => {
        setDisableTableSort(false);
    }, []);

    return (
        <ContentBox
            title="Weather Stations"
            Icon={(props) => <DeviceIcon {...props} deviceType="Weather Station" />}
            className="WeatherStationList"
            variant="xl"
        >
            <ContentBox.Section className="WeatherStationList__header">
                <SimpleGrid columns={2}>
                    <SearchField textFilter={textFilter} onChange={handleTextFilterChange} />
                </SimpleGrid>
            </ContentBox.Section>
            <ContentBox.Section scrollable>
                {weatherStationResults.length === 0 ? (
                    <EmptyState
                        message={
                            !textFilter
                                ? 'There are currently no weather stations'
                                : 'Your search returned no results'
                        }
                    />
                ) : (
                    <SuspenseWrapper loadingComponent={<LevelMonitorListTableSkeleton />}>
                        <WeatherStationListTable
                            devices={weatherStationResults}
                            disableSort={disableTableSort}
                            onSort={handleTableSort}
                        />
                    </SuspenseWrapper>
                )}
            </ContentBox.Section>
        </ContentBox>
    );
}
